<section class="section">
  <ng-content select="[section-header]"></ng-content>
  <div class="kpi-container">
    @for (kpi of sectionData.kpis; track kpi) {
    <gbc-tile [title]="'energy-management-dashboard.' + kpi.humanReadableId | translate">
      <span
        class="info"
        gbc-tile-left
        (click)="
          toggleInfoModal(
            'energy-management-dashboard.' + healthCheckTargetKey + '.' + kpi.humanReadableId + '-tooltip',
            'energy-management-dashboard.' + kpi.humanReadableId
          )
        "
        angulartics2On="click"
        [angularticsAction]="kpi.humanReadableId + 'IconClicked'"
        [angularticsCategory]="'EDB' + humanReadableId"
      >
        <img src="assets/svgs/info-circle_outline.svg" alt="Info" />
      </span>
      <article class="kpi">
        <span class="value"
          >{{ kpi | formatDataPoint : { valueOnly: true } }}
          <small class="unit">{{ kpi | formatDataPoint : { unitOnly: true } }}</small></span
        >
      </article>
    </gbc-tile>
    }
  </div>
  @if (sectionData.healthChecks.length > 0) {
  <div class="health-check-container">
    <gbc-collapsible (toggled)="toggleHealthCheck($event)">
      <div gbc-collapsible-title>
        <span class="collapsible-title">
          @if (someHealthCheckWarning(sectionData.healthChecks)) {
          <img src="assets/svgs/thumbs-down_outline.svg" alt="Warning" />
          } @else {
          <img src="assets/svgs/thumbs-up_outline.svg" alt="OK" />
          }
          <span>{{ 'energy-management-dashboard.health-check' | translate }}</span>
        </span>
      </div>
      <div [formGroup]="healthCheckFormGroup">
        <header class="health-check-header health-check-grid">
          <!--            <span class="value">{{ kpi | formatDataPoint:{ valueOnly: true } }} <small class="unit">{{ kpi | formatDataPoint:{ unitOnly: true } }}</small></span>-->

          <div></div>
          <div>{{ 'energy-management-dashboard.current' | translate }}</div>
          <div>{{ 'energy-management-dashboard.target' | translate }}</div>
          <div>{{ 'energy-management-dashboard.potential-saving' | translate }}</div>
        </header>
        @for (healthcheck of sectionData.healthChecks; track healthcheck) {
        <article class="health-check-item health-check-grid">
          <div>
            @if ([healthCheckStatus.ErrorTargetOvershot, healthCheckStatus.ErrorTargetUndershot].includes(healthcheck.status)) {
            <img src="assets/svgs/thumbs-down_outline.svg" alt="Warning" />
            }@if ([healthCheckStatus.OkTargetNotOvershot, healthCheckStatus.OkTargetNotUndershot].includes(healthcheck.status)) {
            <img src="assets/svgs/thumbs-up_outline.svg" alt="OK" />
            } {{ 'energy-management-dashboard.' + healthcheck.name | translate }}
            <span
              class="info"
              (click)="
                toggleInfoModal(
                  'energy-management-dashboard.' + healthCheckTargetKey + '.' + healthcheck.name + '-tooltip',
                  'energy-management-dashboard.' + healthcheck.name
                )
              "
              ><img src="assets/svgs/info-circle_outline.svg" alt="Info"
            /></span>
          </div>
          <div data-current-display="test">{{ healthcheck | formatDataPoint }}</div>
          <div [ngClass]="['health-check-cell', pending ? 'pending' : ''].join(' ')">
            @if (healthcheck.name !== toggledHealthCheck?.name) {
            <a data-target-display="test" (click)="toggleEditMode(healthcheck)">
              {{ healthcheck.targets[0] | formatDataPoint }}
            </a>
            } @if (healthcheck.name === toggledHealthCheck?.name) {
            <div class="health-check-edit-target">
              <gbc-input-field
                [matchRelativeParentDimensions]="true"
                [formControlName]="toggledHealthCheck?.name || ''"
                [unit]="healthcheck.targets[0].unit"
              ></gbc-input-field>
            </div>
            <div class="button-group">
              <button class="confirm" (click)="onConfirm()"><img src="assets/svgs/check-outline-white.svg" alt="Confirm" /></button>
              <button (click)="onCancel()"><img src="assets/svgs/close_outline.svg" alt="Cancel" /></button>
            </div>
            }
          </div>
          <div>
            <div data-saving-display="test">{{ healthcheck.potentialSaving | formatDataPoint }}</div>
          </div>
          <div>
            <div
              class="info healthcheck"
              (click)="showHealthCheckDetails(healthCheckTargetKey, healthcheck)"
              [title]="'energy-management-dashboard.details' | translate"
              angulartics2On="click"
              angularticsAction="potentialSavingsDetailsClicked"
              [angularticsCategory]="'EDB' + humanReadableId"
            >
              <img src="assets/svgs/arrow-navigation-right_outline.svg" alt="Details" />
            </div>
          </div>
        </article>
        }
      </div>
    </gbc-collapsible>
  </div>
  }
</section>
